import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectDefault from '../common/form/selectDefault';
import LabelAndInputMask from '../common/form/labelAndInputMask';

import {
	setModoTela, initForm
} from './equipamentoActions';
import Th from '../common/table/th';
import THead from '../common/table/tHead';
import Table from '../common/table/table';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Tr from '../common/table/tr';
import TBody from '../common/table/tBody';

class EquipamentoForm extends Component {

	state = {

	}

    componentWillMount() {

    }

    render() {
		
		let readOnly = this.props.excluir ? 'readOnly' : '';

		return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>
							<Field
								name='nome'
								component={LabelAndInput}
								label='Nome *' placeholder='Informe'
								cols='12 8 8 8'
								readOnly={readOnly} />

							<Field
								name='codigo_integracao'
								component={LabelAndInput}
								label='Código de Integração *' placeholder='Informe'
								cols='12 2 2 2'
								readOnly={readOnly} />
						</Row>
						<Row>
							<Field
								name='id_tipo'
								options={this.props.listaTipo}
								component={Select}
								label='Tipo *' placeholder='Informe'
								cols='12 12 12 12'
								readOnly={readOnly} />
						</Row>
						<Row>
							<Field
								name='capacidade'
								component={LabelAndInputNumber}
								label='Capacidade *' placeholder='Informe'
								cols='12 1 1 1'
								minWidth={180}
								readOnly={readOnly}
								title='Quantidade utilizada na fórmula'
								casas={2} />

							<Field
								name='id_unidade_medida'
								options={this.props.listaUnidadeMedida}
								component={Select}
								label='Unidade de Medida *' placeholder='Informe'
								cols='12 1 1 1'
								minWidth={300}
								readOnly={readOnly} />
						</Row>

					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>
				</Form>
			</ContentCard>
		);
    }

}

EquipamentoForm = reduxForm({form: 'equipamentoForm', destroyOnUnmount: false})(EquipamentoForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('equipamentoForm')(state),
	registro: state.equipamento.registro,
	listaTipo: state.equipamento.listaTipo,
	listaUnidadeMedida: state.unidadeMedida.listaSelect
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(EquipamentoForm);
